import React from 'react';

export default function PrismicBreederMissionContent() {
  return (
    <div className="PrismicBreederMissionContent">
      <p>
        Good Dog is on a mission to educate the public, support dog breeders,
        and promote canine health so we can give our dogs the world they
        deserve.
      </p>
    </div>
  );
}
